import React from "react";

type NavigationSectionProps = {
  title?: string;
  children: React.ReactNode;
};

const NavigationSection = ({ title, children }: NavigationSectionProps): JSX.Element => (
  <div className="mt-xl">
    {title && <div className="text-secondary uppercase text-xs py-sm px-2xl tracking-wider">{title}</div>}
    <ul>{children}</ul>
  </div>
);

export default NavigationSection;
